import React, { useEffect, useState } from 'react';
import {
    Carousel,
    CarouselContent,
    CarouselItem,
} from "@postcheesy/ui-lib/molecules";

interface VedetteData {
    text: string;
    hyperlink: string;
}

export const Vedettes: React.FC = () => {
    const [vedetteData, setVedetteData] = useState<VedetteData | null>(null);
    const [isSmallScreen, setIsSmallScreen] = useState<boolean>(window.innerWidth <= 768);
    const [imageSize, setImageSize] = useState<{ y: number }>({ y: 600 });
    const apiUrl = import.meta.env.VITE_API_URL;

    useEffect(() => {
        const fetchVedetteData = async () => {
            try {
                const response = await fetch(`${apiUrl}/vedette`);
                const data = await response.json();
                setVedetteData(data);
            } catch (error) {
                // console.error('Failed to fetch vedette data:', error);
            }
        };
        fetchVedetteData();

        const handleResize = () => {
            const isSmall = window.innerWidth <= 768;
            setIsSmallScreen(isSmall);
            setImageSize({ y: 800 });
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getImageUrl = (index: number) =>
        `${apiUrl}/vedette/image?y=${imageSize.y}&ImageIndex=${index}`;

    const handleCarouselClick = () => {
        if (vedetteData?.hyperlink) {
            window.open(vedetteData.hyperlink, '_blank');
        }
    };

    if (!vedetteData) return null;
    /////////////////////FIX SMALL SCREEN UX
    return isSmallScreen ? (
        <Carousel onClick={handleCarouselClick} className='relative'>
            <CarouselContent>
                {[1, 2, 3].map((index) => (
                    <CarouselItem key={index} className='w-full h-[300px] overflow-hidden'>
                        <img
                            src={getImageUrl(index)}
                            alt={`Vedette image ${index}`}
                            className='w-full h-full object-cover'
                        />
                    </CarouselItem>
                ))}
            </CarouselContent>
            <div className="absolute bottom-0 p-4 bg-opacity-50 bg-black text-white text-center w-full">{vedetteData.text}</div>
        </Carousel>
    ) : (
        <div className='relative w-full'>
            <div className="flex items-center justify-between gap-2 cursor-pointer" onClick={handleCarouselClick}>
                {[1, 2, 3].map((index) => (
                    <div key={index} className="w-1/3 h-[300px] overflow-hidden">
                        <img
                            src={getImageUrl(index)}
                            alt={`Vedette image ${index}`}
                            className='w-full h-full object-cover'
                        />
                    </div>
                ))}

            </div>
            <a href={vedetteData.hyperlink}>
                <div className="absolute bottom-0 p-4 bg-opacity-50 bg-black text-white text-center w-full">

                    {vedetteData.text}
                </div>
            </a>
        </div>
    );
};